const fiats = {
  RUB: {
    value: 'RUB',
    title: 'WithdrawToCard | rubTitle',
    description: 'WithdrawToCard | rubDescription',
    icon: 'rub',
  },
  USD: {
    value: 'USD',
    title: 'WithdrawToCard | usdTitle',
    description: 'WithdrawToCard | usdDescription',
    icon: 'usd',
  },
  EUR: {
    value: 'EUR',
    title: 'WithdrawToCard | eurTitle',
    description: 'WithdrawToCard | eurDescription',
    icon: 'eur',
  },
}

export { fiats }
